// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__2bG2w","deleteBtnColor":"style_deleteBtnColor__X3r0r","modalTextUpperClass":"style_modalTextUpperClass__CZi8-"};